import {
  styled,
  IconButton,
  Paper,
  Typography,
  Box,
  Button,
} from "@mui/material";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#fff",
  height: theme.spacing(7),
  width: theme.spacing(7),
  borderRadius: "50%",
  boxShadow: theme.shadows[3],
  "&:hover": { backgroundColor: "#f5f5f5" },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 2,
  height: "100%",
}));

const MessageListContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  maxHeight: theme.spacing(37.5),
  overflowY: "auto",
  paddingRight: theme.spacing(1),
}));

const LoadingContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: 1,
  maxWidth: "80%",
}));

const DetailBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#fafafa",
  border: "1px solid #ccc",
  borderRadius: 1,
  marginTop: theme.spacing(1),
  padding: theme.spacing(1),
  maxHeight: theme.spacing(25),
  overflowY: "auto",
  width: "90%",
  fontSize: "0.8rem",
  whiteSpace: "pre-wrap",
  fontFamily: "monospace",
}));

const StyledText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  maxWidth: "80%",
  fontSize: 15,
  fontWeight: 420,
}));

const StyledButton = styled(Button)(() => ({
  textDecoration: "underline",
  fontSize: 12,
}));

const motionDivStyle = {
  position: "fixed",
  bottom: 90,
  right: 30,
  zIndex: 1300,
  width: 600,
  maxHeight: 500,
};

export {
  StyledIconButton,
  motionDivStyle,
  StyledPaper,
  MessageListContainer,
  StyledText,
  StyledButton,
  LoadingContainer,
  DetailBox,
};
